import { Container } from "react-bootstrap";
import Footer from "./Footer";
import Navigation from "./Navigation";

function PrivacyPoliciesDataProtection() {
  return (
    <div className="position-relative">
      <Navigation />
      <PrivacyPage />
      <Footer contact={true} />
    </div>
  );
}

function PrivacyPage() {
  return (
    <Container className="mobile-padding position-relative ">
      <div>
        <div className="banner-title">
          KRIYA MEDICAL TECHNOLOGIES PRIVATE LIMITED
        </div>
        <div className="banner-description">
          PRIVACY POLICY – Website and Data Protection Policy
        </div>
        <div style={{ height: "40px" }}></div>
        <div className="banner-description">
          <b>1. KRIYA’s Commitment to Data Privacy Protection</b><br /><br />
          Protecting the security and privacy of your personal data is important to KRIYA Medical Technologies Private Limited ("KRIYA"). We conduct our business in compliance with applicable data protection and privacy laws, including the Information Technology Act, 2000 and the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011.
          This Privacy Policy outlines what data KRIYA may collect via its website, how it uses and safeguards that data, and with whom it may share the information.
          <br /><br />
          <b>2. Collection of Personal Data</b><br /><br />
          KRIYA does not collect personal data (such as name, address, email, or phone number) unless you voluntarily provide it through website forms, job applications, surveys, or newsletter registrations. Providing personal data implies consent, unless otherwise permitted under applicable law.
          <br /><br />
          <b>3. Purpose of Use</b><br /><br />
          When you submit personal data, KRIYA may use it to:
          Respond to your inquiries
          Process transactions, requests, or applications
          Provide access to services, information, or offers
          Improve customer relationship and support
          Send relevant communications or updates based on your expressed interests (opt-in only)
          Conduct surveys or research to enhance services
          You may withdraw your consent for direct marketing or research communications by writing to: admin@kriyamed.com.
          <br /><br />
          <b>4. Purpose Limitation</b><br /><br />
          KRIYA uses personal data only for the purpose disclosed at the time of collection or for directly related uses, unless:
          Required by law or governmental/judicial authorities
          Needed to establish or defend a legal claim
          Necessary to prevent fraud or unauthorized access
          Required for contract performance with the user
          <br /><br />
          <b>5. Automatic Collection of Non-Personal Data</b><br /><br />
          When you access our website, we may collect non-personal data (such as browser type, device information, pages visited, and time spent) to:
          Analyse user engagement and behaviour
          Improve content, layout, and functionality
          Monitor website performance and security
          <br /><br />
          <b>6. Cookies</b><br /><br />
          KRIYA uses cookies to:
          Provide faster and personalized content delivery
          Understand browsing behaviour and interests
          Facilitate login or form-filling experiences
          You can manage cookie preferences via your browser settings. Cookies are read only by the server that placed them and cannot execute programs or viruses.
          <br /><br />
          <b>7. Data Security</b><br /><br />
          KRIYA applies technical and organizational measures to protect your personal data from:
          Unauthorized access or disclosure
          Accidental or unlawful destruction or alteration
          Misuse or data breach
          Our website employs HTTPS, secure servers, and restricted access control.
          <br /><br />
          <b>8. Children’s Privacy</b><br /><br />
          KRIYA does not knowingly collect personal information from children under the age of 18. Our website is not intended for or directed at minors.
          <br /><br />
          <b>9. Links to Other Websites</b><br /><br />
          Our website may contain links to third-party websites. KRIYA is not responsible for the privacy practices or content of those external sites. Users are advised to review each site’s privacy policy and terms of use independently.
          <br /><br />
          <b>10. Feedback and Surveys</b><br /><br />
          KRIYA may request feedback via email or surveys. Any data you voluntarily provide through such interactions may be used to improve services. By submitting such content, you grant KRIYA the right to use it without compensation.
          <br /><br />
          <b>11. Consent</b><br /><br />
          By using the KRIYA website, you:
          Agree to the terms set out in this Privacy Policy
          Consent to the collection, use, and sharing of your information as described
          Confirm you are acting on your free will
          If you do not agree with this policy, please discontinue use of the website.
          <br /><br />
          <b>12. User Rights and Access</b><br /><br />
          You have the right to:
          Request access to your personal data
          Request corrections or deletion of inaccurate data
          Withdraw consent at any time
          Raise concerns by contacting the Data Protection Officer at admin@kriyamed.com
          <br /><br />
          <b>13. Changes to This Policy</b><br /><br />
          KRIYA reserves the right to update or modify this Privacy Policy at any time. Updates will be posted on this page with a revised effective date. Users are encouraged to review this page periodically.
        </div>
      </div>
    </Container>
  );
}

export default PrivacyPoliciesDataProtection;